export default __webpack_public_path__ + "static/pistachiostrawberrybarfi-bac58abb74549a4e3a6c241028cffe15.png";